import React, { Children, useState } from 'react';
import { useMatchMedia } from '@udemy/hooks';
import { ContentArea } from '@udemy/react-layout-components';
import { AutoPlayCarousel } from '@udemy/react-structure-components';
import { SlideIndicatorDots, SlideIndicatorDashes } from '../slide-indicator/slide-indicator.react-component';
import styles from "./slim-hero-banner.module.css";
export const SlimHeroBanner = ({
  children,
  intervalDuration,
  ...otherProps
}) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const isSmMax = useMatchMedia('sm-max');
  const hasCoarsePointer = useMatchMedia('(any-pointer: coarse)');
  const isMobile = Boolean(isSmMax && hasCoarsePointer);
  const pageCount = Children.toArray(children).length;
  const shouldShowPager = pageCount > 1 && !isMobile;
  const slideIndicatorProps = {
    className: styles['slide-indicator'],
    intervalDuration,
    pageCount,
    visiblePageIndex: slideIndex
  };
  const handleMutation = event => setSlideIndex(Number(event.visiblePageIndex));
  return /*#__PURE__*/React.createElement(ContentArea, {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(AutoPlayCarousel, Object.assign({
    allowScroll: isMobile,
    gridFullWidthItems: true,
    intervalDuration: intervalDuration,
    onMutation: handleMutation,
    pageByFullWidth: true,
    prioritizeTouch: isMobile,
    showPager: shouldShowPager
  }, otherProps), children), pageCount > 1 && (isMobile ? /*#__PURE__*/React.createElement(SlideIndicatorDashes, slideIndicatorProps) : /*#__PURE__*/React.createElement(SlideIndicatorDots, slideIndicatorProps)));
};
//# sourceMappingURL=slim-hero-banner.react-component.js.map